<template>
  <base-container ref="container">
    <ArtisanGrid
      ref="grid"
      metaKey="SysApiInfo"
      @syncApi="syncApi"
      :leftOption="option"
    >
    </ArtisanGrid>
  </base-container>
</template>

<script>
import { syncApi } from "@/api/sys/api";
export default {
  data() {
    return {
      groups: [],
      option: {
        width: "20%",
        title: "分组",
        treeKey: "ApiGroupOption",
        searchField: "apiGroup",
      },
    };
  },
  created() {},
  methods: {
    syncApi() {
      this.$refs.container.confirm({ msg: "确认同步API数据" }).then(() => {
        syncApi().then((res) => {
          this.$refs.grid.reload();
        });
      });
    },
  },
};
</script>

<style></style>
